import {
  getAssetById,
  getAssetSubTypesByAssetTypeId,
  getAllParentAssetTypes,
  updateAsset,
} from "../../../Redux/Assets/AssetsActions";
import {
  getAllBuildings,
  getAmenitiesByBuildingId,
} from "../../../Redux/Buildings/BuildingActions";
import validator, { ValidationField } from "../../../Util/validator";
import Loading from "../../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../../Redux/store";
import { Link, useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import arrowIcon from "../../../Assets/arrowleft.png";
import styles from "./EditAsset.module.scss";
import { useEffect, useState } from "react";

function EditAsset() {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const {
    updateAssetLoading,
    getAssetByIdLoading,
    assetByIdData,
    parentAssetTypesData,
    parentAssetTypesLoading,
    assetSubTypesLoading,
    assetSubTypesData,
  } = useSelector((state: RootState) => state.assets);
  const {
    buildings,
    buildingsLoading,
    getAmenitiesByBuildingIdList,
    getAmenitiesByBuildingIdLoading,
  } = useSelector((state: RootState) => state.buildings);
  const [assetCode, setAssetCode] = useState<string>("");
  const [assetName, setAssetName] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [serialNumber, setSerialNumber] = useState<string>("");
  const [modelNumber, setModelNumber] = useState<string>("");
  const [status, setStatus] = useState<string>("");
  const [buildingId, setBuildingId] = useState<string>("");
  const [amenityId, setAmenityId] = useState<string>("");
  const [assetTypeId, setAssetTypeId] = useState<string>("");
  const [assetSubTypeId, setAssetSubTypeId] = useState<string>("");
  const [errors, setErrors] = useState<{
    assetCode: string;
    assetName: string;
    description: string;
    serialNumber: string;
    modelNumber: string;
    status: string;
    amenityId: string;
    assetTypeId: string;
    assetSubTypeId: string;
    buildingId: string;
  }>({
    assetCode: "",
    assetName: "",
    description: "",
    serialNumber: "",
    modelNumber: "",
    status: "",
    amenityId: "",
    assetTypeId: "",
    assetSubTypeId: "",
    buildingId: "",
  });

  const updateAssetHandler = () => {
    const fields: ValidationField[] = [
      {
        key: "buildingId",
        type: "text",
        value: buildingId,
      },
      {
        key: "assetName",
        type: "text",
        value: assetName,
      },
      {
        key: "description",
        type: "text",
        value: description,
      },
      {
        key: "serialNumber",
        type: "text",
        value: serialNumber,
      },
      {
        key: "status",
        type: "text",
        value: status,
      },
      {
        key: "assetTypeId",
        type: "text",
        value: assetTypeId,
      },
    ];

    const { errors: fieldErrors, isValid } = validator(fields);
    setErrors({ ...errors, ...fieldErrors });

    if (isValid) {
      if (!updateAssetLoading && id) {
        const successHandler = () => {
          navigate("/admin/assets", {
            replace: true,
          });
        };

        dispatch(
          updateAsset({
            assetId: parseInt(id),
            buildingId: parseInt(buildingId),
            assetCode,
            assetName,
            description,
            serialNumber,
            modelNumber,
            status,
            amenityId: parseInt(amenityId),
            assetTypeId: parseInt(assetTypeId),
            assetSubTypeId: assetSubTypeId ? parseInt(assetSubTypeId) : null,
            successHandler,
          }),
        );
      }
    }
  };

  useEffect(() => {
    dispatch(getAllBuildings());
    dispatch(getAllParentAssetTypes());
    if (id) {
      dispatch(getAssetById({ assetId: parseInt(id) }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (assetByIdData) {
      setAssetCode(assetByIdData?.assetCode || "");
      setAssetName(assetByIdData?.assetName || "");
      setDescription(assetByIdData?.description || "");
      setSerialNumber(assetByIdData?.serialNumber || "");
      setModelNumber(assetByIdData?.modelNumber || "");
      setStatus(assetByIdData?.status || "");
      setBuildingId(assetByIdData?.buildingId?.toString() || "");
      setAmenityId(assetByIdData?.amenityId?.toString() || "");
      setAssetTypeId(assetByIdData?.assetTypeId?.toString() || "");
      setAssetSubTypeId(
        assetByIdData?.assetSubTypeId != null
          ? assetByIdData.assetSubTypeId.toString()
          : "",
      );

      if (assetByIdData?.buildingId) {
        dispatch(
          getAmenitiesByBuildingId({
            buildingId: assetByIdData.buildingId.toString(),
          }),
        );
      }

      if (assetByIdData?.assetTypeId) {
        dispatch(
          getAssetSubTypesByAssetTypeId({
            assetTypeId: assetByIdData.assetTypeId.toString(),
          }),
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetByIdData]);

  return (
    <div className={styles.mainContainer}>
      <Link to="/admin/assets" replace className={styles.backButtonContainer}>
        <button className={styles.button}>
          <img src={arrowIcon} alt="arrowIcon" className={styles.arrowIcon} />
          Back to Assets
        </button>
      </Link>
      <div className={styles.headingContainer}>
        <h1 className={styles.heading}>Update Asset</h1>
      </div>
      <div className={styles.formContainer}>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Building</p>
          <select
            className={styles.input}
            value={buildingId}
            onChange={(e) => {
              setBuildingId(e.target.value);
              setAmenityId("");
              dispatch(
                getAmenitiesByBuildingId({ buildingId: e.target.value }),
              );
            }}
          >
            {!buildingId && <option value="">Select Building</option>}
            {buildings?.map((building) => (
              <option key={building.buildingId} value={building.buildingId}>
                {building.buildingName}
              </option>
            ))}
          </select>
          <p className={styles.error}>{errors.buildingId}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Amenity</p>
          <select
            className={styles.input}
            value={amenityId}
            onChange={(e) => setAmenityId(e.target.value)}
          >
            {!amenityId && <option value="">Select Amenity</option>}
            {getAmenitiesByBuildingIdList?.map((amenity, i) => (
              <option key={i} value={amenity.amenityId}>
                {amenity?.name} - {amenity?.amenityTypeName}
              </option>
            ))}
          </select>
          <p className={styles.error}>{errors.amenityId}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Asset Code</p>
          <input
            type="text"
            className={styles.input}
            value={assetCode}
            onChange={(e) => setAssetCode(e.target.value)}
          />
          <p className={styles.error}>{errors.assetCode}</p>
        </div>
        <div className={styles.doubleInputContainer}>
          <div className={styles.inputContainer}>
            <p className={styles.label}>Asset Name</p>
            <input
              type="text"
              className={styles.input}
              value={assetName}
              onChange={(e) => setAssetName(e.target.value)}
            />
            <p className={styles.error}>{errors.assetName}</p>
          </div>
        </div>
        <div className={styles.textAreaContainer}>
          <p className={styles.label}>Description</p>
          <textarea
            className={styles.textArea}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={4}
          />
          <p className={styles.error}>{errors.description}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Serial Number</p>
          <input
            type="text"
            className={styles.input}
            value={serialNumber}
            onChange={(e) => setSerialNumber(e.target.value)}
          />
          <p className={styles.error}>{errors.serialNumber}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Model Number</p>
          <input
            type="text"
            className={styles.input}
            value={modelNumber}
            onChange={(e) => setModelNumber(e.target.value)}
          />
          <p className={styles.error}>{errors.modelNumber}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Status</p>
          <select
            className={styles.input}
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            {!status && <option value="">Select Status</option>}
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
          <p className={styles.error}>{errors.status}</p>
        </div>

        <div className={styles.inputContainer}>
          <p className={styles.label}>Asset Type</p>
          <select
            className={styles.input}
            value={assetTypeId}
            onChange={(e) => {
              setAssetTypeId(e.target.value);
              setAssetSubTypeId("");
              dispatch(
                getAssetSubTypesByAssetTypeId({ assetTypeId: e.target.value }),
              );
            }}
          >
            {!assetTypeId && <option value="">Select Asset Type</option>}
            {parentAssetTypesData?.map((assetType, i) => (
              <option key={i} value={assetType?.assetTypeId}>
                {assetType?.type}
              </option>
            ))}
          </select>
          <p className={styles.error}>{errors.assetTypeId}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Asset Sub Type</p>
          <select
            className={styles.input}
            value={assetSubTypeId}
            onChange={(e) => setAssetSubTypeId(e.target.value)}
          >
            <option value="">None</option>
            {assetSubTypesData?.map((assetSubType, i) => (
              <option key={i} value={assetSubType?.assetTypeId}>
                {assetSubType?.type}
              </option>
            ))}
          </select>
          <p className={styles.error}>{errors.assetSubTypeId}</p>
        </div>

        {(updateAssetLoading ||
          getAssetByIdLoading ||
          getAmenitiesByBuildingIdLoading ||
          assetSubTypesLoading ||
          buildingsLoading ||
          parentAssetTypesLoading) && <Loading />}

        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={updateAssetHandler}>
            Update Asset
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditAsset;
